import { CHAT } from 'constants.js'

import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(() => ({
    messages: {
        paddingTop: 10,
        paddingLeft: 15,
        paddingBottom: 10,
        width: '100%',
        height: `calc(100% - ${CHAT.FORM_HEIGHT}px)`,
        overflow: 'auto',
    },
    fullScreen: {
        paddingLeft: 0,
    },
    msg: {
        padding: '8px 0',
        margin: 0,
    },
    msgFrom: {
        marginLeft: 2,
        fontWeight: 'bold',
        fontSize: 13,
        paddingRight: 8,
        textTransform: 'capitalize',
    },
    msgBody: {
        display: 'inline',
        paddingLeft: 10,
        wordBreak: 'break-word',
        hyphens: 'auto',
        textTransform: 'none',
    },
    msgLike: {
        paddingRight: 5,
    },
    msgLikeCount: {
        paddingRight: 4,
    },
    msgLikeBtn: {
        paddingTop: 2,
        lineHeight: 0,
    },
    newMessageButton: {
        position: 'absolute',
        right: '50%',
        bottom: 0,
        transform: 'translateY(-100%)',
        zIndex: 3,

        '@media (max-width: 767px)': {
            position: 'fixed',
        },
    },
}))
